exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mission-location-map-popup{display:flex;flex-direction:column;justify-content:center;align-items:center}.mission-location-map-source{font-style:italic}.mission-location-map-note{font-weight:700}\n", ""]);

// exports
